import React from 'react'
import PropTypes from "prop-types";
import { i18n } from 'core/i18n'

import './examples.scss'

export const Examples = ({ offers = [], isFullInterestRate }) => {
    const { FormattedText } = i18n;

    const renderExamples = () => {
        return offers.map(({ supIndex, example, offerValues }) => {
            const { tin, tae, months } = offerValues
            const {
                cancelMonths,
                cancelCost,
                exampleInterestAmountCancelled,
                exampleAmount,
                exampleInterestAmount
            } = example
            const isSameOfferTaeTin = offerValues.tin === offerValues.tae

            const exampleText = isSameOfferTaeTin
                ? "contractsView-contractView_depositOfferExampleSameTaeTin"
                : "contractsView-contractView_depositOfferExampleTaeTin"

            const injectedStringsExampleText = [
                exampleAmount,
                tae,
                ...(isSameOfferTaeTin ? [] : [tin]),
                months
            ]

            const injectedStringsBreachCondition = [
                months,
                cancelMonths,
                cancelCost,
                exampleInterestAmountCancelled
            ]
            
            return (
                <p key={supIndex}>
                    <sup>{ supIndex }</sup> <FormattedText value={exampleText} injectedStrings={injectedStringsExampleText} />
                    <br />
                    <FormattedText value="contractsView-contractView_depositOfferExampleCondition" injectedStrings={[months, exampleInterestAmount]} />
                    <br />
                    <FormattedText value="contractsView-contractView_depositOfferExampleBreachCondition" injectedStrings={injectedStringsBreachCondition} />
                </p>
            )
        })
    }

    const renderExamplesPassport = () => {
        return offers.map(({ supIndex, example, offerValues }) => {
            const { tin, months } = offerValues
            const {
                cancelMonths,
                cancelCost,
                exampleInterestAmountCancelled,
                exampleInterestAmount,
                exampleAmount
            } = example

            return (
                <p key={supIndex}>
                    <sup>{ supIndex }</sup> <FormattedText value="contractsView-contractView_depositOfferExampleTin" injectedStrings={[exampleAmount, tin, months]}
                    />
                    <br />
                    <FormattedText
                        value="contractsView-contractView_depositOfferExampleCondition"
                        injectedStrings={[months, exampleInterestAmount]}
                    /> 
                    <br />
                    <FormattedText
                        value="contractsView-contractView_depositOfferExampleBreachConditionTin"
                        injectedStrings={[months, cancelMonths, cancelCost, exampleInterestAmountCancelled]}
                    />
                </p>
            )
        })
    }

    return (
        <div className='representative-examples'>
            {
                isFullInterestRate
                    ? renderExamples()
                    : renderExamplesPassport()
            }
        </div>
    )
}

Examples.propTypes = {
    offers: PropTypes.array.isRequired,
    isPassportCountry: PropTypes.bool.isRequired,
};
